import { Box, FormLabel, Grid, Typography } from '@mui/material'
import { ChartOptionElement } from 'gqlTypes'
import useChartOptions from 'hooks/useChartOptions'
import React, { useEffect } from 'react'
import { ReportElement as GqlReportElement } from 'gqlTypes'
import { getCohortToUse } from 'util/getBarChartData'
import useElementCohortsAndSubgroups from 'hooks/useElementCohortsAndSubgroups'
import useReportDetails from 'hooks/useReportDetails'

type Props = {
  cohort?: string
  subgroup?: string
  subgroupItem?: string
  pastResults?: string
}

const PdfReportElementSettings: React.FC<Props> = ({
  cohort,
  subgroup,
  subgroupItem,
  pastResults,
}) => {
  return (
    <Box py={2}>
      <Grid container rowSpacing={2} columnSpacing={4}>
        {cohort && (
          <Grid item>
            <FormLabel style={{ color: 'black' }}>Cohort: </FormLabel>
            <Typography component="span">{cohort}</Typography>
          </Grid>
        )}
        {subgroup && (
          <Grid item>
            <FormLabel style={{ color: 'black' }}>Subgroup: </FormLabel>
            <Typography component="span">{subgroup}</Typography>
          </Grid>
        )}
        {subgroup && subgroupItem && (
          <Grid item>
            <FormLabel style={{ color: 'black' }}>{`${subgroup}: `}</FormLabel>
            <Typography component="span">{subgroupItem}</Typography>
          </Grid>
        )}
        {pastResults && (
          <Grid item>
            <FormLabel style={{ color: 'black' }}>Past Results: </FormLabel>
            <Typography component="span">{pastResults}</Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default PdfReportElementSettings
